module.exports = __webpack_public_path__ + "fonts/fontello.7c436b76.ttf";